import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { IntegratorItem } from "../listing/IntegratorItem";

interface IIntegratorContext {
    integratorItems: IntegratorItem[];
    isLoading: boolean;
    setIntegratorItems(integratorItems: IntegratorItem[]): void;
    addIntegratorItem(integratorItem: IntegratorItem): void;
    deleteIntegratorItem(integratorId: string): void;
}

const initialContextState: IIntegratorContext = {
    integratorItems: [],
    isLoading: false,
    setIntegratorItems: contextFunctionInit,
    addIntegratorItem: contextFunctionInit,
    deleteIntegratorItem: contextFunctionInit
};

export const IntegratorContext = createContext<IIntegratorContext>(initialContextState);
